import { _, ts } from '_core';

import { getIndustryName } from '../../common/utils/get-series-name';

export const getTabName = (tab: 'signal_count' | 'pipeline_count' | 'sp_pipeline_count') => {
  if (tab == 'signal_count') return 'Signal';
  if (tab == 'pipeline_count') return 'Pipeline';
  if (tab == 'sp_pipeline_count') return 'SP Pipeline';
};

export const prepareNames = (
  data: ts.types.widgets.TableData,
  by: 'rbics_l1_id' | 'rbics_l2_id' | 'rbics_l3_id' | 'rbics_l4_id',
  resources: ts.StoreState['resources']
) => {
  const newData = data.map((item) => {
    const newItem = {} as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      let newKey = key;
      if (key != 'other' && key != 'date') {
        newKey = getIndustryName(key, by, resources);
        newItem[_.startCase(newKey)] = item[key];
      }
    });
    return newItem;
  });

  return newData;
};
